import type { SVGProps } from "react";

import { cn } from "@homeinstead/ui";
import ChevronSVG from "./chevron.svg";

export interface ChevronProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export default function Chevron({ className, ...props }: ChevronProps) {
  return (
    <ChevronSVG
      className={cn(
        "h-3 w-3 fill-new-beginnings-base stroke-new-beginnings-base",
        className,
      )}
      {...props}
    />
  );
}
